import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import * as moment from 'moment';
import * as _ from "lodash";
import { MatDialog } from '@angular/material';
import { RenewalWindowComponent } from '../renewal-window/renewal-window.component';
import { formatDate } from '@angular/common';
var IndividualDashboardComponent = /** @class */ (function () {
    function IndividualDashboardComponent(globalService, matDialog, reportService, _dashboardService, transformerMangSer, ngxLoader, router, route, injectedData) {
        this.globalService = globalService;
        this.matDialog = matDialog;
        this.reportService = reportService;
        this._dashboardService = _dashboardService;
        this.transformerMangSer = transformerMangSer;
        this.ngxLoader = ngxLoader;
        this.router = router;
        this.route = route;
        this.injectedData = injectedData;
        this.signalStrength = 0;
        this.bars = [1, 2, 3, 4, 5];
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.allParameters = [];
        this.commonColumns = ["Transformer Id", "Deviceid", "DATE"];
        this.electricalParams = [];
        this.filter = {};
        this.date = {};
        this.windingtemprature = [];
        this.parameterValuedisplay = {};
        this.currentselectedduration = {};
        this.graph = {
            layout: {
                autosize: true,
                xaxis: {
                    title: {
                        text: 'Time',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000',
                        }
                    },
                },
                yaxis: {
                    title: {
                        text: 'Value',
                        font: {
                            family: 'Arial',
                            size: 18,
                            color: '#000000'
                        }
                    }
                },
                shapes: []
            },
            config: { displaylogo: false, modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'] }
        };
        this.selectedTransformer = null;
        this.transformerList = [];
        this.selectedParameter = null;
        this.parameterList = [];
        this.parameterListTemp = [];
        this.masterparameterList = [];
        this.dashboard_transformer_id = 0;
        this.durationList = [
            { id: 1, name: 'Today' },
            { id: 2, name: 'Yesterday' },
            { id: 3, name: 'This Week' },
            { id: 4, name: 'This Month' },
            { id: 5, name: 'Last Month' },
            { id: 6, name: 'Custom' }
        ];
        this.selectedDuration = this.durationList[0];
        this.data = [];
        this.showtableData = false;
        this.batteryStatusImgUrl = "assets/images/fullbattery.png";
        this.networkFlag = false;
        this.selectedMeter = 1;
        this.hasMeter2Data = false;
    }
    IndividualDashboardComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payloadtogetTransformer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log("adsasadd", this.injectedData);
                        if (this.injectedData == "KR313-1427") {
                            this.value1 = "Zone 3(Star)";
                            this.value2 = "Zone 4(Delta)";
                        }
                        else if (this.injectedData == "KR312-1426") {
                            this.value1 = "Zone 1(Delta)";
                            this.value2 = "Zone 2(Star)";
                        }
                        if (this.currentUserData.roleid !== 1) {
                            this.getRenewalData();
                        }
                        return [4 /*yield*/, this.dashboard_transformerid_display()];
                    case 1:
                        _a.sent();
                        this.markerSize = 10;
                        this.pointerCap = {
                            radius: 7,
                            border: {
                                width: 5
                            }
                        };
                        this.pointerBorder = {
                            color: 'green',
                            width: 1
                        };
                        this.lineStyle = {
                            color: 'red'
                        };
                        this.ngxLoader.startLoader('individualdashboard');
                        payloadtogetTransformer = {
                            "countryid": null,
                            "stateid": null,
                            "cityid": null,
                            "zoneid": null,
                            "locationid": null,
                            "transformerid": null,
                        };
                        return [4 /*yield*/, this.getParameterList()];
                    case 2:
                        _a.sent();
                        this.ngxLoader.stopLoader('individualdashboard');
                        return [2 /*return*/];
                }
            });
        });
    };
    IndividualDashboardComponent.prototype.getParameterList = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.globalService.golbalMaster('filterparameters').subscribe(function (response) {
                if (response && response.code === '1' && response.result.length > 0) {
                    console.log('response====Filter Parameters========', response);
                    //this.selectedParameter = response.result[0];
                    //this.parameterList = response.result;
                    _this.parameterListTemp = response.result;
                    resolve(_this.parameterListTemp);
                }
            });
        });
    };
    IndividualDashboardComponent.prototype.getfilteredTransformers = function (payloadtogetTransformer, userData) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.globalService.getfilteredTransformers(payloadtogetTransformer, localStorage.getItem('userData')).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var i, currentDate, manufactureYear, duration;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(response && response.code === '1' && response.result.length > 0)) return [3 /*break*/, 2];
                            console.log('response=====Individual Dashboard=========', response);
                            this.selectedTransformer = response.result[0];
                            this.transformerList = response.result.map(function (a) {
                                a.transformerDetail = a.transformerid + "[" + a.sitename + "]";
                                return a;
                            });
                            //this.transformerList = response.result;
                            //this.setParameterListForTransformer(this.selectedTransformer);
                            if (this.dashboard_transformer_id != 0) {
                                console.log("dataaaaa", this.dashboard_transformer_id);
                                for (i = 0; i < response.result.length; i++) {
                                    if (response.result[i].transformerid == this.dashboard_transformer_id) {
                                        this.selectedTransformer = response.result[i];
                                    }
                                }
                            }
                            else {
                                this.selectedTransformer = response.result[0];
                            }
                            currentDate = moment(moment().format('YYYY-MM-DD'));
                            manufactureYear = moment(moment(this.selectedTransformer.manufacturingdate).format('YYYY-MM-DD'));
                            this.ageTransformer = currentDate.diff(manufactureYear, 'years');
                            duration = this.durationSelectionAlert({ id: 1, name: 'Today' });
                            return [4 /*yield*/, this.getData(this.selectedTransformer, this.selectedParameter, duration)];
                        case 1:
                            _a.sent();
                            resolve(this.transformerList);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    /* setParameterListForTransformer(selectedTransformer: any) {
      if (selectedTransformer.harmonic_current === 0) {
        this.parameterList = _.remove(this.parameterList, function (n) {
          return n.name !== "Harmonics Current";
        });
      }
      if (selectedTransformer.harmonic_voltage === 0) {
        this.parameterList = _.remove(this.parameterList, function (n) {
          return n.name !== "Harmonics Voltage";
        });
      }
      if (selectedTransformer.systemKwh === "0") {
        this.parameterList = _.remove(this.parameterList, function (n) {
          return n.name !== "System_kwh";
        });
      }
    } */
    IndividualDashboardComponent.prototype.durationSelectionAlert = function (selectedDuration) {
        console.log('selectedDuration====', selectedDuration);
        var date = {
            startdate: moment().format('YYYY-MM-DD'),
            enddate: moment().format('YYYY-MM-DD'),
            filters: 'Today'
        };
        if (selectedDuration.id == 2) {
            date.startdate = moment().subtract(1, 'day').format('YYYY-MM-DD');
            date.enddate = moment().subtract(1, 'day').format('YYYY-MM-DD');
            date.filters = 'Yesterday';
        }
        if (selectedDuration.id == 3) {
            date.startdate = moment().startOf('week').format('YYYY-MM-DD');
            date.enddate = moment().endOf('week').format('YYYY-MM-DD');
            date.filters = 'This Week';
        }
        if (selectedDuration.id == 4) {
            date.startdate = moment().startOf('month').format('YYYY-MM-DD');
            date.enddate = moment().endOf('month').format('YYYY-MM-DD');
            date.filters = 'This Month';
        }
        if (selectedDuration.id == 5) {
            date.startdate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
            date.enddate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            date.filters = 'Last Month';
        }
        if (selectedDuration.id == 6) {
            this.showDateRange = true;
        }
        else {
            this.showDateRange = false;
        }
        console.log('selectedDuration==durationSelectionAlert==', date);
        return date;
    };
    IndividualDashboardComponent.prototype.transformerSelection = function (selectedTransformer) {
        /* this.parameterList=_.cloneDeep(this.parameterListTemp);
        this.setParameterListForTransformer(selectedTransformer); */
        var currentDate = moment(moment().format('YYYY-MM-DD'));
        var manufactureYear = moment(moment(selectedTransformer.manufacturingdate).format('YYYY-MM-DD'));
        this.ageTransformer = currentDate.diff(manufactureYear, 'years');
        var selectedDuration = this.durationSelectionAlert(this.selectedDuration);
        this.getData(selectedTransformer, this.selectedParameter, selectedDuration);
    };
    IndividualDashboardComponent.prototype.parameterSelection = function (selectedParameter) {
        var selectedDuration = this.durationSelectionAlert(this.selectedDuration);
        this.getData(this.selectedTransformer, selectedParameter, this.currentselectedduration);
    };
    IndividualDashboardComponent.prototype.durationSelection = function (selectedDuration) {
        var duration = this.durationSelectionAlert(selectedDuration);
        this.getData(this.selectedTransformer, this.selectedParameter, duration);
    };
    IndividualDashboardComponent.prototype.changeDateRange = function (event) {
        console.log("event----------", event);
        if (this.showDateRange) {
            this.date = {
                startdate: moment(event.value[0]).format('YYYY-MM-DD'),
                enddate: moment(event.value[1]).format('YYYY-MM-DD'),
                filters: "Custom"
            };
            this.getData(this.selectedTransformer, this.selectedParameter, this.date);
        }
    };
    IndividualDashboardComponent.prototype.getData = function (selectedTransformer, selectedParameter, selectedDuration) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, filteredParams, endDate;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.currentselectedduration = selectedDuration;
                this.ngxLoader.startLoader('individualdashboardgraph');
                console.log('payload=====Selected Parameter====', selectedParameter);
                payload = { transformerid: '', startdate: '', enddate: '', filter: '' };
                payload.transformerid = "'" + selectedTransformer.transformerid + "'";
                payload.startdate = selectedDuration.startdate;
                payload.enddate = selectedDuration.enddate;
                payload.filter = selectedDuration.filters;
                this.filter.transformerId = selectedTransformer.transformerid;
                if (selectedDuration.filters === 'Today' || selectedDuration.filters === 'Yesterday') {
                    this.filter.filter = selectedDuration.filters;
                    this.filter.date = selectedDuration.enddate;
                }
                else if (selectedDuration.filters === 'This Week' || selectedDuration.filters === 'This Month' || selectedDuration.filters === 'Last Month') {
                    this.filter.filter = selectedDuration.filters;
                    this.filter.startDate = selectedDuration.startdate;
                    ;
                    this.filter.endDate = selectedDuration.enddate;
                }
                else if (selectedDuration.startdate && selectedDuration.enddate) {
                    console.log("In custom date");
                    delete this.filter.date;
                    console.log("selected duration start date", selectedDuration.startdate + "Selected Duration  lasrdate", selectedDuration.enddate);
                    this.filter.filter = selectedDuration.filters;
                    this.filter.startDate = selectedDuration.startdate;
                    this.filter.endDate = selectedDuration.enddate;
                }
                this.windingtemprature = [];
                console.log("Filters for winding temp", this.filter);
                console.log('payload=========', payload);
                filteredParams = [];
                endDate = new Date(payload.enddate);
                endDate.setDate(endDate.getDate() + 1);
                payload.enddate = formatDate(endDate, 'yyyy-MM-dd', 'en-US');
                this._dashboardService.loadIndividualDashboard(payload).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var isParameter, i, params, elecParameters, i, element, responseData, filter_1, currentTime, currentOffset, ISTOffset, ISTTime, receivedTime, timeDifferenceInMilliseconds, timeDifferenceInMinutes;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(response && response.code === '1' && response.result.length > 0)) return [3 /*break*/, 2];
                                isParameter = false;
                                for (i = 0; i < response.elecParams.length; i++) {
                                    if (response.elecParams[i] == 'Lug Temperature') {
                                        isParameter = true;
                                    }
                                }
                                params = response.physicalParams;
                                console.log("/////////////Parameter", params);
                                elecParameters = ['KVA', 'PF', 'Ampere', 'Voltage', 'Load Percentage', 'I Unbalance', 'V Unbalance', 'V Variance', 'KVAr', 'KW', 'Lug Temperature'];
                                params = params.concat(elecParameters);
                                console.log("Params++++++++++++", isParameter);
                                for (i = 0; i < this.parameterListTemp.length; i++) {
                                    element = this.parameterListTemp[i];
                                    if (params.includes(element.name)) {
                                        if (element.name == "Lug Temperature") {
                                            if (isParameter) {
                                                filteredParams.push(element);
                                            }
                                        }
                                        else {
                                            filteredParams.push(element);
                                        }
                                    }
                                }
                                filteredParams = _.map(filteredParams, function (o) {
                                    if (o.name === 'Harmonics Current') {
                                        o.name = 'Current THD';
                                    }
                                    else if (o.name === 'Harmonics Voltage') {
                                        o.name = 'Voltage THD';
                                    }
                                    return o;
                                });
                                this.parameterList = filteredParams;
                                console.log("All Parameters", this.parameterList);
                                //console.log("Params+++++parameterList+++++++",this.parameterList);
                                if (selectedParameter) {
                                }
                                else {
                                    this.selectedParameter = this.parameterList[0];
                                    selectedParameter = this.parameterList[0];
                                    //console.log("+++++this.selectedParameter+++++++",this.selectedParameter);
                                }
                                responseData = _.flatMap(response.result, function (o) {
                                    var readings = JSON.parse(o.readings);
                                    if (readings.hasOwnProperty("Network")) {
                                        _this.networkFlag = true;
                                        _this.NetworkValue = readings.Network;
                                        if (_this.NetworkValue >= 2 && _this.NetworkValue <= 9) {
                                            _this.signalStrength = 1;
                                        }
                                        else if (_this.NetworkValue >= 10 && _this.NetworkValue <= 14) {
                                            _this.signalStrength = 2;
                                        }
                                        else if (_this.NetworkValue >= 15 && _this.NetworkValue <= 19) {
                                            _this.signalStrength = 3;
                                        }
                                        else if (_this.NetworkValue >= 20 && _this.NetworkValue <= 25) {
                                            _this.signalStrength = 4;
                                        }
                                        else if (_this.NetworkValue >= 26 && _this.NetworkValue <= 31) {
                                            _this.signalStrength = 5;
                                        }
                                    }
                                    if (readings.hasOwnProperty("System_kwh_2")) {
                                        _this.hasMeter2Data = true;
                                    }
                                    else {
                                        _this.hasMeter2Data = false;
                                    }
                                    o.modifiedreadings = readings;
                                    o.Load = ((((Number(readings.L1) + Number(readings.L2) + Number(readings.L3)) / 3) / Number(o.ratedLoad)) * 100);
                                    var avgCurrent = (Number(readings.L1) + Number(readings.L2) + Number(readings.L3)) / 3;
                                    var currentDeviation = _.maxBy([(Number(readings.L1) - avgCurrent), (Number(readings.L2) - avgCurrent), (Number(readings.L3) - avgCurrent)]);
                                    o.iUnbalance = ((currentDeviation * 100) / avgCurrent).toFixed(2);
                                    var avgVoltage = (Number(readings.RY_Voltage) + Number(readings.YB_Voltage) + Number(readings.BR_Voltage)) / 3;
                                    var voltageDeviation = _.maxBy([(Number(readings.RY_Voltage) - avgVoltage), (Number(readings.YB_Voltage) - avgVoltage), (Number(readings.BR_Voltage) - avgVoltage)]);
                                    o.vUnbalance = ((voltageDeviation * 100) / avgVoltage).toFixed(2);
                                    o.Frequency = readings.Frequency;
                                    return o;
                                });
                                console.log('response====loadIndividualDashboard======', response);
                                this.enabledParameters = response.physicalParams;
                                return [4 /*yield*/, this.getSelectedParameterFilter(selectedParameter, response.paramsalertValues)];
                            case 1:
                                filter_1 = _a.sent();
                                if (selectedParameter.showcalulationtable == 1) {
                                    this.showtableData = true;
                                }
                                else {
                                    this.showtableData = false;
                                }
                                this.getChartData(responseData, filter_1);
                                currentTime = new Date();
                                currentOffset = currentTime.getTimezoneOffset();
                                ISTOffset = 330;
                                ISTTime = new Date(currentTime.getTime() + (ISTOffset + currentOffset) * 60000);
                                receivedTime = new Date(response.result[response.result.length - 1].DATE);
                                timeDifferenceInMilliseconds = ISTTime.getTime() - receivedTime.getTime();
                                timeDifferenceInMinutes = Math.floor(timeDifferenceInMilliseconds / (1000 * 60));
                                console.log("Time ==============", timeDifferenceInMinutes);
                                if (timeDifferenceInMinutes > 30) {
                                    this.batteryStatusImgUrl = "assets/images/lowbattery.png";
                                }
                                else {
                                    this.batteryStatusImgUrl = "assets/images/fullbattery.png";
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                this.showtableData = false;
                                this.data = [];
                                this.ngxLoader.stopLoader('individualdashboardgraph');
                                this.batteryStatusImgUrl = "assets/images/lowbattery.png";
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }, function (error) {
                    _this.ngxLoader.stopLoader('individualdashboardgraph');
                });
                return [2 /*return*/];
            });
        });
    };
    IndividualDashboardComponent.prototype.calculatewindingtempbycal = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response3, response2, columnLength, i, addition, LoadPercentage, windingTemprature, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this.reportService.getReportData(this.filter).toPromise()];
                    case 1:
                        response3 = _a.sent();
                        if (!(response3 && response3.reportData && response3.reportData.length > 0)) return [3 /*break*/, 3];
                        this.PhaseApparentPowerValue = response3.reportData[response3.reportData.length - 1]['3_Phase_Apparent_Power'];
                        this.avgPowerFactorValue = response3.reportData[response3.reportData.length - 1]['Avg_Power_Factor'];
                        this.phaseActivePower = response3.reportData[response3.reportData.length - 1]['3_Phase_Active_Power'];
                        console.log('REPORT DATA:', response3.reportData);
                        return [4 /*yield*/, this.transformerMangSer.getTransformerDetails({ transformerId: this.selectedTransformer.transformerid, deletedFlag: 'D' }).toPromise()];
                    case 2:
                        response2 = _a.sent();
                        console.log('TransformerDetails:', response2);
                        this.gradient = response2.details.message.description[0]['kwhreading'];
                        this.kvarating = response2.details.message.description[0]['ratedLoad'];
                        columnLength = response3.reportData.length;
                        this.windingtemprature = []; // Initialize the array here
                        for (i = 0; i < columnLength; i++) {
                            addition = Number(response3.reportData[i]['L1']) + Number(response3.reportData[i]['L2']) + Number(response3.reportData[i]['L3']);
                            LoadPercentage = ((addition / 3) / Number(this.kvarating)) * 100;
                            windingTemprature = Number(response3.reportData[i]['Oil_Temperature']) + ((this.gradient * LoadPercentage) / 100);
                            this.windingtemprature.push(windingTemprature.toFixed(2));
                        }
                        console.log("Winding Temperature", this.windingtemprature);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Error in calculatewindingtempbycal:', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    IndividualDashboardComponent.prototype.getSelectedParameterFilter = function (selectedParameter, paramsalertValuesList) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var parameterValue, obj;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(">>>>>>>>><<<<<<<<>>>>>>>", paramsalertValuesList);
                        return [4 /*yield*/, this.calculatewindingtempbycal()];
                    case 1:
                        _a.sent();
                        parameterValue = {};
                        this.parameterValuedisplay = {};
                        obj = { filter: '', type: 'direct', phases: null, parameterValue: null, ismultiBreakpoint: false, multiBreakpointValue: [] };
                        if (selectedParameter.id == 1) {
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apOiltemperature" });
                            obj.filter = 'Oil_Temperature';
                            /* this.parameterValuedisplay.name1="Oil Temperature";
                            this.parameterValuedisplay.value1=parameterValue.parameterValue; */
                            obj.parameterValue = parameterValue.parameterValue;
                        }
                        if (selectedParameter.id == 2) {
                            this.parameterValuedisplay.name1 = "Rated KVA ";
                            this.parameterValuedisplay.value1 = this.selectedTransformer.kvarating;
                            obj.phases = { phaseA: 'R_apparent_Power', phaseB: 'Y_apparent_Power', phaseC: 'B_apparent_Power' };
                        }
                        if (selectedParameter.id == 3) {
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apLowPowerfactor" });
                            obj.phases = { phaseA: 'R_Power_Factor', phaseB: 'Y_Power_Factor', phaseC: 'B_Power_Factor' };
                            obj.filter = 'PF';
                            /* this.parameterValuedisplay.name1="PF";
                            this.parameterValuedisplay.value1=parameterValue.parameterValue; */
                            obj.parameterValue = parameterValue.parameterValue;
                        }
                        if (selectedParameter.id == 4) {
                            obj.filter = 'Frequency';
                        }
                        if (selectedParameter.id == 5) {
                            obj.ismultiBreakpoint = true;
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apOverload" });
                            obj.multiBreakpointValue.push(parameterValue.parameterValue);
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apUnderload" });
                            obj.multiBreakpointValue.push(parameterValue.parameterValue);
                            /*
                            this.parameterValuedisplay.name1="OverLoad";
                            this.parameterValuedisplay.value1=parameterValue.parameterValue;
                            parameterValue=_.find(paramsalertValuesList,{parameterName: "apUnderload"});
                            this.parameterValuedisplay.name2="Underload";
                            this.parameterValuedisplay.value2=parameterValue.parameterValue; */
                            obj.phases = { phaseA: 'L1', phaseB: 'L2', phaseC: 'L3' };
                        }
                        if (selectedParameter.id == 6) {
                            obj.ismultiBreakpoint = true;
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apHighvolt" });
                            obj.multiBreakpointValue.push(parameterValue.parameterValue);
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apLowvolt" });
                            obj.multiBreakpointValue.push(parameterValue.parameterValue);
                            obj.phases = { phaseA: 'R_Ph_N', phaseB: 'Y_Ph_N', phaseC: 'B_Ph_N' };
                        }
                        if (selectedParameter.id == 7) {
                            obj.phases = { phaseA: 'IR_THD', phaseB: 'IY_THD', phaseC: 'IB_THD' };
                        }
                        if (selectedParameter.id == 8) {
                            obj.phases = { phaseA: 'VR_THD', phaseB: 'VY_THD', phaseC: 'VB_THD' };
                        }
                        if (selectedParameter.id == 9) {
                            obj.filter = 'Ambient_Temperature';
                        }
                        if (selectedParameter.id == 10) {
                            obj.filter = 'Humidity';
                        }
                        if (selectedParameter.id == 11) {
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apWindingtemperature" });
                            obj.filter = 'Winding_Temperature';
                            /* this.parameterValuedisplay.name1="Winding Temperature";
                            this.parameterValuedisplay.value1=parameterValue.parameterValue; */
                            obj.parameterValue = parameterValue.parameterValue;
                        }
                        if (selectedParameter.id == 12) {
                            obj.filter = 'Load';
                        }
                        if (selectedParameter.id == 13) {
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apIunbalance" });
                            obj.filter = 'iUnbalance';
                            /* this.parameterValuedisplay.name1="I Unbalance";
                            this.parameterValuedisplay.value1=parameterValue.parameterValue; */
                            obj.parameterValue = parameterValue.parameterValue;
                        }
                        if (selectedParameter.id == 14) {
                            parameterValue = _.find(paramsalertValuesList, { parameterName: "apVunbalance" });
                            obj.filter = 'vUnbalance';
                            /* this.parameterValuedisplay.name1="V Unbalance";
                            this.parameterValuedisplay.value1=parameterValue.parameterValue; */
                            obj.parameterValue = parameterValue.parameterValue;
                        }
                        if (selectedParameter.id == 15) {
                            obj.phases = { phaseA: 'R_Ph_N', phaseB: 'Y_Ph_N', phaseC: 'B_Ph_N' };
                        }
                        if (selectedParameter.id == 16) {
                            obj.phases = { phaseA: 'R_Reactive_Power', phaseB: 'Y_Reactive_Power', phaseC: 'B_Reactive_Power' };
                        }
                        if (selectedParameter.id == 17) {
                            obj.phases = { phaseA: 'R_Active_Power', phaseB: 'Y_Active_Power', phaseC: 'B_Active_Power' };
                            obj.filter = 'KW';
                        }
                        if (selectedParameter.id == 18) {
                            obj.filter = 'System_kwh';
                            obj.type = 'json';
                        }
                        if (selectedParameter.id == 19) {
                            obj.filter = 'Oil_Level';
                        }
                        if (selectedParameter.id == 20) {
                            obj.filter = 'Winding_Temp_By_Cal';
                        }
                        if (selectedParameter.id == 21) {
                            obj.phases = { phaseA: 'Lug_Temp_R', phaseB: 'Lug_Temp_Y', phaseC: 'Lug_Temp_B' };
                        }
                        if (selectedParameter.id == 22) {
                            obj.filter = 'Compariosion';
                            obj.phases = { name: "Comparision" };
                        }
                        if (selectedParameter.id == 23) {
                            obj.filter = 'Kvarh';
                            obj.phases = { name: "Kvarh" };
                        }
                        return [2 /*return*/, obj];
                }
            });
        });
    };
    IndividualDashboardComponent.prototype.getChartData = function (data, filterObj) {
        var _this = this;
        this.data = [];
        this.graph.layout.shapes = [];
        if (filterObj.parameterValue) {
            this.graph.layout.shapes = [
                {
                    type: 'line',
                    xref: 'paper',
                    x0: 0,
                    y0: filterObj.parameterValue,
                    x1: 1,
                    y1: filterObj.parameterValue,
                    line: {
                        color: 'rgb(255, 0, 0)',
                        width: 4
                    }
                }
            ];
        }
        else if (filterObj.ismultiBreakpoint) {
            for (var i = 0; i < filterObj.multiBreakpointValue.length; i++) {
                this.graph.layout.shapes.push({
                    type: 'line',
                    xref: 'paper',
                    x0: 0,
                    y0: filterObj.multiBreakpointValue[i],
                    x1: 1,
                    y1: filterObj.multiBreakpointValue[i],
                    line: {
                        color: 'rgb(255, 0, 0)',
                        width: 4
                    }
                });
            }
        }
        if (filterObj.filter && filterObj.type === 'direct') {
            var filterKey_1 = filterObj.filter;
            console.log(" Selected value", filterKey_1);
            var needsvalue = void 0;
            var bottomvalue = void 0;
            var value = [];
            if (filterKey_1 === "Winding_Temp_By_Cal") {
                value = this.windingtemprature;
            }
            else if (filterKey_1 === "Oil_Level") {
                // Special handling for oil level
                value = _.map(data, function (o) {
                    var oilLevel = _this.selectedMeter === 1 ?
                        o[filterKey_1] :
                        o[filterKey_1 + '_2'];
                    return Number(oilLevel);
                });
                // Add shapes for oil level thresholds
                this.graph.layout.shapes = [
                    {
                        type: 'line',
                        xref: 'paper',
                        x0: 0,
                        y0: 4,
                        x1: 1,
                        y1: 4,
                        line: {
                            color: 'rgb(255, 0, 0)',
                            width: 2,
                            dash: 'dash'
                        }
                    },
                    {
                        type: 'line',
                        xref: 'paper',
                        x0: 0,
                        y0: 5,
                        x1: 1,
                        y1: 5,
                        line: {
                            color: 'rgb(255, 165, 0)',
                            width: 2,
                            dash: 'dash'
                        }
                    },
                    {
                        type: 'line',
                        xref: 'paper',
                        x0: 0,
                        y0: 6,
                        x1: 1,
                        y1: 6,
                        line: {
                            color: 'rgb(255, 0, 0)',
                            width: 2,
                            dash: 'dash'
                        }
                    }
                ];
            }
            else {
                // For other parameters including oil temperature
                value = _.map(data, function (o) {
                    var val = _this.selectedMeter === 1 ?
                        o[filterKey_1] :
                        o.modifiedreadings[filterKey_1 + '_2'];
                    return val ? Number(val) : 0;
                });
            }
            var time_1 = _.map(data, 'DATE');
            this.innerWidth = window.innerWidth;
            console.log("Window  Size", this.innerWidth);
            var lengthofarray = value.length - 1;
            if (filterKey_1 !== "Oil_Level") {
                if (value[lengthofarray] == 4) {
                    needsvalue = 4;
                    bottomvalue = '4%';
                }
                else if (value[lengthofarray] == 5) {
                    needsvalue = 5;
                    bottomvalue = '5%';
                }
                else if (value[lengthofarray] == 6) {
                    needsvalue = 6;
                    bottomvalue = '6%';
                }
                else {
                    needsvalue = 0;
                    bottomvalue = '0%';
                }
            }
            var widthOfCanvas = void 0;
            if (this.innerWidth < 500) {
                widthOfCanvas = 350;
            }
            else {
                widthOfCanvas = 700;
            }
            this.canvasWidth = widthOfCanvas;
            this.needleValue = needsvalue;
            this.centralLabel = '';
            this.name = '';
            this.bottomLabel = bottomvalue;
            this.options = {
                hasNeedle: true,
                needleColor: 'black',
                needleUpdateSpeed: 5000,
                arcColors: ['red', 'green', 'red'],
                arcDelimiters: ['20', '80'],
                rangeLabel: ['Low', 'High'],
                needleStartValue: 0,
            };
            var selectedDuration = this.durationSelectionAlert(this.selectedDuration);
            var startdate = new Date(selectedDuration.startdate);
            var enddate = new Date(selectedDuration.enddate);
            var time_difference = startdate.getTime() - enddate.getTime();
            var days_difference = -(time_difference / (1000 * 60 * 60 * 24)) % 365;
            console.log("drtn=", days_difference);
            console.log("====getOilTempData======", value, time_1);
            var ValuesOilTemp = value.length - 1;
            this.ValuesForOilTemp = value[ValuesOilTemp];
            if (filterObj.parameterValue == null) {
                this.RangeColor = "green";
            }
            else {
                if (this.ValuesForOilTemp >= filterObj.parameterValue) {
                    this.RangeColor = "red";
                }
                else {
                    this.RangeColor = "green";
                }
            }
            console.log("oil temp data", filterObj.parameterValue);
            if (days_difference >= 4) {
                var traces = {
                    x: time_1,
                    y: value,
                    mode: 'lines',
                    type: 'scatter',
                    name: filterKey_1 + (this.selectedMeter === 2 ? '_2' : '')
                };
                this.data = [traces];
            }
            else {
                var traces = {
                    x: time_1,
                    y: value,
                    mode: 'lines+markers',
                    type: 'scatter',
                    name: filterKey_1 + (this.selectedMeter === 2 ? '_2' : '')
                };
                this.data = [traces];
            }
            if (this.showtableData) {
                console.log("value now", this.windingtemprature);
                console.log("value now data", data);
                if (filterKey_1 === "Winding_Temp_By_Cal") {
                    var numericalValues = this.windingtemprature.map(function (val) { return Number(val); });
                    if (this.showtableData) {
                        this.tableData = {
                            max: _.max(numericalValues),
                            min: _.min(numericalValues),
                            range: _.max(numericalValues) - _.min(numericalValues),
                            avg: _.sum(numericalValues) / numericalValues.length
                        };
                    }
                }
                else if (filterKey_1 === "Oil_Level") {
                    var values = data.map(function (item) {
                        var val = Number(_this.selectedMeter === 1 ?
                            item[filterKey_1] :
                            item[filterKey_1 + '_2']);
                        return val;
                    });
                    var max = Number(_.max(values));
                    var min = Number(_.min(values));
                    var range = max - min;
                    var avg = _.sum(values) / values.length;
                    this.tableData = {
                        max: max,
                        min: min,
                        range: range,
                        avg: avg
                    };
                }
                else {
                    if (this.showtableData) {
                        var values = data.map(function (item) {
                            return Number(_this.selectedMeter === 1 ?
                                item[filterKey_1] :
                                item[filterKey_1 + '_2']);
                        });
                        var max = Number(_.max(values));
                        var min = Number(_.min(values));
                        var range = max - min;
                        var avg = _.sum(values) / values.length;
                        this.tableData = {
                            max: max,
                            min: min,
                            range: range,
                            avg: avg
                        };
                    }
                }
            }
        }
        else if (filterObj.filter && filterObj.type === 'json') {
            var filterKey_2 = filterObj.filter;
            var value = _.map(data, function (o) {
                return _this.selectedMeter === 1 ?
                    o.modifiedreadings[filterKey_2] :
                    o.modifiedreadings[filterKey_2 + '_2'];
            });
            var time_2 = _.map(data, 'DATE');
            var traces = {
                x: time_2,
                y: value,
                mode: 'lines+markers',
                type: 'scatter',
                name: filterKey_2 + (this.selectedMeter === 2 ? '_2' : '')
            };
            this.data = [traces];
        }
        var time = _.map(data, 'DATE');
        var date = _.map(data, 'mdate');
        var timelength = time.length - 1;
        this.latestDataDate = time[timelength];
        if (filterObj.phases) {
            var filterKey_3 = filterObj.phases;
            var phaseAValue;
            var phaseBValue;
            var phaseCValue;
            var phaseAValue2;
            var phaseBValue2;
            var phaseCValue2;
            if (filterObj.filter == "KW" || filterObj.filter == "PF") {
                phaseAValue = _.map(data, function (o) { return Math.abs(o.modifiedreadings[filterKey_3.phaseA]); });
                phaseBValue = _.map(data, function (o) { return Math.abs(o.modifiedreadings[filterKey_3.phaseB]); });
                phaseCValue = _.map(data, function (o) { return Math.abs(o.modifiedreadings[filterKey_3.phaseC]); });
                if (filterKey_3.phaseA + '_2' in data[0].modifiedreadings) {
                    phaseAValue2 = _.map(data, function (o) { return Math.abs(o.modifiedreadings[filterKey_3.phaseA + '_2']); });
                    phaseBValue2 = _.map(data, function (o) { return Math.abs(o.modifiedreadings[filterKey_3.phaseB + '_2']); });
                    phaseCValue2 = _.map(data, function (o) { return Math.abs(o.modifiedreadings[filterKey_3.phaseC + '_2']); });
                }
            }
            else {
                phaseAValue = _.map(data, function (o) { return o.modifiedreadings[filterKey_3.phaseA]; });
                phaseBValue = _.map(data, function (o) { return o.modifiedreadings[filterKey_3.phaseB]; });
                phaseCValue = _.map(data, function (o) { return o.modifiedreadings[filterKey_3.phaseC]; });
                if (filterKey_3.phaseA + '_2' in data[0].modifiedreadings) {
                    phaseAValue2 = _.map(data, function (o) { return o.modifiedreadings[filterKey_3.phaseA + '_2']; });
                    phaseBValue2 = _.map(data, function (o) { return o.modifiedreadings[filterKey_3.phaseB + '_2']; });
                    phaseCValue2 = _.map(data, function (o) { return o.modifiedreadings[filterKey_3.phaseC + '_2']; });
                }
            }
            var averageVoltageData = _.map(data, function (o) { return o['Average_Voltage']; });
            var lengthForAValue = phaseAValue.length - 1;
            if (this.selectedMeter === 1) {
                this.valueForPhaseA = phaseAValue[lengthForAValue];
                this.valueForPhaseB = phaseBValue[lengthForAValue];
                this.valueForPhaseC = phaseCValue[lengthForAValue];
                this.AverageVoltageValue = averageVoltageData[lengthForAValue];
            }
            else {
                this.valueForPhaseA = phaseAValue2[lengthForAValue];
                this.valueForPhaseB = phaseBValue2[lengthForAValue];
                this.valueForPhaseC = phaseCValue2[lengthForAValue];
                if ('Average_Voltage_2' in data[0].modifiedreadings) {
                    this.AverageVoltageValue = _.map(data, function (o) { return o.modifiedreadings['Average_Voltage_2']; })[lengthForAValue];
                }
                else {
                    this.AverageVoltageValue = averageVoltageData[lengthForAValue];
                }
            }
            var tracesList = [];
            var traces1 = {
                x: time,
                y: this.selectedMeter === 1 ? phaseAValue : phaseAValue2,
                name: 'R Phase' + (this.selectedMeter === 2 ? '_2' : ''),
                mode: 'lines+markers',
                type: 'scatter',
                marker: {
                    color: 'red'
                }
            };
            var traces2 = {
                x: time,
                y: this.selectedMeter === 1 ? phaseBValue : phaseBValue2,
                name: 'Y Phase' + (this.selectedMeter === 2 ? '_2' : ''),
                mode: 'lines+markers',
                type: 'scatter',
                marker: {
                    color: 'yellow'
                }
            };
            var traces3 = {
                x: time,
                y: this.selectedMeter === 1 ? phaseCValue : phaseCValue2,
                name: 'B Phase' + (this.selectedMeter === 2 ? '_2' : ''),
                mode: 'lines+markers',
                type: 'scatter',
                marker: {
                    color: 'blue'
                }
            };
            tracesList.push(traces1, traces2, traces3);
            if (filterObj.phases.phaseA === 'L1') {
                if (this.selectedMeter === 1) {
                    var tempTraces = {
                        x: time,
                        y: _.map(data, function (o) { return o.modifiedreadings['LN']; }),
                        name: 'LN',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'green'
                        }
                    };
                    tracesList.push(tempTraces);
                }
                else if (this.selectedMeter === 2 && 'LN_2' in data[0].modifiedreadings) {
                    var tempTraces2 = {
                        x: time,
                        y: _.map(data, function (o) { return o.modifiedreadings['LN_2']; }),
                        name: 'LN_2',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'darkgreen'
                        }
                    };
                    tracesList.push(tempTraces2);
                }
            }
            if (filterObj.phases.phaseA === 'R_Power_Factor') {
                if (this.selectedMeter === 1) {
                    var tempTraces = {
                        x: time,
                        y: _.map(data, function (o) { return Math.abs(o.modifiedreadings['Avg_Power_Factor']); }),
                        name: 'Avg Power Factor',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'green'
                        }
                    };
                    tracesList.push(tempTraces);
                }
                else if (this.selectedMeter === 2 && 'Avg_Power_Factor_2' in data[0].modifiedreadings) {
                    var tempTraces2 = {
                        x: time,
                        y: _.map(data, function (o) { return Math.abs(o.modifiedreadings['Avg_Power_Factor_2']); }),
                        name: 'Avg Power Factor_2',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'darkgreen'
                        }
                    };
                    tracesList.push(tempTraces2);
                }
            }
            if (filterObj.phases.phaseA === 'R_Ph_N') {
                if (this.selectedMeter === 1) {
                    var tempTraces = {
                        x: time,
                        y: _.map(data, function (o) { return o['Average_Voltage']; }),
                        name: 'Average Voltage',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'green'
                        }
                    };
                    tracesList.push(tempTraces);
                }
                else if (this.selectedMeter === 2 && 'Average_Voltage_2' in data[0].modifiedreadings) {
                    var tempTraces2 = {
                        x: time,
                        y: _.map(data, function (o) { return o.modifiedreadings['Average_Voltage_2']; }),
                        name: 'Average Voltage_2',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'darkgreen'
                        }
                    };
                    tracesList.push(tempTraces2);
                }
            }
            if (filterObj.phases.phaseA === 'R_apparent_Power') {
                if (this.selectedMeter === 1) {
                    var tempTraces = {
                        x: time,
                        y: _.map(data, function (o) { return o['3_Phase_Apparent_Power']; }),
                        name: '3 Phase Apparent Power',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'green'
                        }
                    };
                    tracesList.push(tempTraces);
                }
                else if (this.selectedMeter === 2 && '3_Phase_Apparent_Power_2' in data[0].modifiedreadings) {
                    var tempTraces2 = {
                        x: time,
                        y: _.map(data, function (o) { return o.modifiedreadings['3_Phase_Apparent_Power_2']; }),
                        name: '3 Phase Apparent Power_2',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'darkgreen'
                        }
                    };
                    tracesList.push(tempTraces2);
                }
            }
            if (filterObj.phases.phaseA === 'R_Active_Power') {
                if (this.selectedMeter === 1) {
                    var tempTraces = {
                        x: time,
                        y: _.map(data, function (o) { return o['3_Phase_Active_Power']; }),
                        name: '3 Phase Active Power',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'green'
                        }
                    };
                    tracesList.push(tempTraces);
                }
                else if (this.selectedMeter === 2 && '3_Phase_Active_Power_2' in data[0].modifiedreadings) {
                    var tempTraces2 = {
                        x: time,
                        y: _.map(data, function (o) { return o.modifiedreadings['3_Phase_Active_Power_2']; }),
                        name: '3 Phase Active Power_2',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'darkgreen'
                        }
                    };
                    tracesList.push(tempTraces2);
                }
            }
            this.data = tracesList;
            if (filterObj.filter == "Compariosion") {
                if (filterObj.phases.name == 'Comparision') {
                    var WindingData = void 0;
                    var windingTempName = void 0;
                    var tracesList_1 = [];
                    console.log(">>>>>>>>>>>>>>><<<<<<<<<<<<_---------", this.enabledParameters);
                    if (this.enabledParameters.includes('Winding Temperature')) {
                        windingTempName = "Winding Temperature";
                        WindingData = _.map(data, function (o) { return o['Winding_Temperature']; });
                    }
                    else if (this.enabledParameters.includes('Winding_Temp_By_Cal')) {
                        windingTempName = "Calculated Winding temperature";
                        WindingData = this.windingtemprature;
                    }
                    if (this.enabledParameters.includes('Winding Temperature') || this.enabledParameters.includes('Winding_Temp_By_Cal')) {
                        var traces5 = {
                            x: time,
                            y: WindingData,
                            name: windingTempName,
                            mode: 'lines+markers',
                            type: 'scatter',
                            marker: {
                                color: 'purple'
                            }
                        };
                        tracesList_1.push(traces5);
                    }
                    if (this.enabledParameters.includes('Oil Temperature')) {
                        var traces1_1 = {
                            x: time,
                            y: _.map(data, function (o) { return o['Oil_Temperature']; }),
                            name: 'Oil Temperature',
                            mode: 'lines+markers',
                            type: 'scatter',
                            marker: {
                                color: 'red'
                            }
                        };
                        tracesList_1.push(traces1_1);
                    }
                    if (this.enabledParameters.includes('Oil Level')) {
                        var traces2_1 = {
                            x: time,
                            y: _.map(data, function (o) { return o['Oil_Level']; }),
                            name: 'Oil Level',
                            mode: 'lines+markers',
                            type: 'scatter',
                            marker: {
                                color: 'black'
                            }
                        };
                        tracesList_1.push(traces2_1);
                    }
                    if (this.enabledParameters.includes('Ambient Temperature')) {
                        var traces3_1 = {
                            x: time,
                            y: _.map(data, function (o) { return o['Ambient_Temperature']; }),
                            name: 'Ambient Temperature',
                            mode: 'lines+markers',
                            type: 'scatter',
                            marker: {
                                color: 'blue'
                            }
                        };
                        tracesList_1.push(traces3_1);
                    }
                    var traces4 = {
                        x: time,
                        y: _.map(data, function (o) { return o['Load']; }),
                        name: 'Load %',
                        mode: 'lines+markers',
                        type: 'scatter',
                        marker: {
                            color: 'green'
                        }
                    };
                    tracesList_1.push(traces4);
                    this.data = tracesList_1;
                }
            }
            if (filterObj.phases.name == 'Kvarh') {
                var lagKvarh = void 0;
                var LeadKvarh = void 0;
                if (this.selectedMeter === 1) {
                    lagKvarh = _.map(data, function (o) { return o.modifiedreadings['Lag_KvArh']; });
                    LeadKvarh = _.map(data, function (o) { return o.modifiedreadings['Lead_KvArh']; });
                }
                else {
                    lagKvarh = _.map(data, function (o) { return o.modifiedreadings['Lag_KvArh_2']; });
                    LeadKvarh = _.map(data, function (o) { return o.modifiedreadings['Lead_KvArh_2']; });
                }
                var tracesList_2 = [];
                var traces1_2 = {
                    x: time,
                    y: lagKvarh,
                    name: 'Lag_Kvarh' + (this.selectedMeter === 2 ? '_2' : ''),
                    mode: 'lines+markers',
                    type: 'scatter',
                    marker: {
                        color: 'red'
                    }
                };
                tracesList_2.push(traces1_2);
                var traces2_2 = {
                    x: time,
                    y: LeadKvarh,
                    name: 'Lead_Kvarh' + (this.selectedMeter === 2 ? '_2' : ''),
                    mode: 'lines+markers',
                    type: 'scatter',
                    marker: {
                        color: 'blue'
                    }
                };
                tracesList_2.push(traces2_2);
                this.data = tracesList_2;
            }
        }
        this.ngxLoader.stopLoader('individualdashboardgraph');
    };
    IndividualDashboardComponent.prototype.dashboard_transformerid_display = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payloadtogetTransformer;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.injectedData != "") {
                            console.log("dashboard_transformerid_display", this.injectedData);
                            this.dashboard_transformer_id = this.injectedData;
                        }
                        payloadtogetTransformer = {
                            "countryid": null,
                            "stateid": null,
                            "cityid": null,
                            "zoneid": null,
                            "locationid": null,
                            "transformerid": null,
                        };
                        return [4 /*yield*/, this.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), JSON.stringify(localStorage.getItem('userData')))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IndividualDashboardComponent.prototype.selectMeter = function (meter) {
        this.selectedMeter = meter;
        this.getData(this.selectedTransformer, this.selectedParameter, this.currentselectedduration);
    };
    IndividualDashboardComponent.prototype.getRenewalData = function () {
        var _this = this;
        this._dashboardService.getRenewalDate(this.currentUserData.userid).subscribe(function (response) {
            if (response.result.length > 0) {
                if (response.result[0].RenewalDays >= 365 || response.result[0].dashboardaccess == 0) {
                    var domObject = document.getElementById("denyDashboardAccess");
                    domObject.style.opacity = '0.1';
                    var dialogRef = _this.matDialog.open(RenewalWindowComponent, {
                        autoFocus: false,
                        height: '85%', width: '50%', data: { data: response.result }, disableClose: true, panelClass: 'custom-dialog-container'
                    });
                    dialogRef.afterClosed().subscribe(function (response) {
                    });
                }
            }
        });
    };
    return IndividualDashboardComponent;
}());
export { IndividualDashboardComponent };
